import { render, staticRenderFns } from "./SuiteAppNavigatorOLD.vue?vue&type=template&id=a405fbae&"
import script from "./SuiteAppNavigatorOLD.vue?vue&type=script&lang=js&"
export * from "./SuiteAppNavigatorOLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports